import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Typography,
  Paper,
  Divider,
  Select,
  IconButton,
  Button,
  MenuItem,
  Menu,
  Stack,
  Pagination,
  PaginationItem,
  TextField,
  InputAdornment,
  Grid,
} from "@mui/material";
import { TOTALLIMIT } from "../../../utils/localStorage";
import { styled } from "@mui/material/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Switch from "@mui/material/Switch";
import ArrowDown from "../../../assets/icons/ArrowDown.svg";
import ActiveAddButton from "../../../assets/icons/ActiveAddButton.svg";
import React, { useState, useEffect } from "react";
import BackArrow from "../../../assets/icons/BackArrow.svg";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import CircularProgress from "@mui/material/CircularProgress";
import EditButton from "../../../assets/icons/EditButton.svg";
import TrashButton from "../../../assets/icons/TrashButton.svg";
import {
  setIsOpenModelAddQuestionMaster,
  setIsOpenModelEditQuestionMaster,
  deleteRoleMastersList,
  updateQuestionMasterList,
  deleteQuestionChecklistMasterList,
  getChecklistQuestionMasterList,
} from "../../../redux/actions/mastersAction";
import { setLoaderSaveButton } from "../../../redux/actions/userActions";
import AddQuestionMasterModel from "./AddQuestionMasterModel";
import EditQuestionMasterModel from "./EditQuestionMasterModel";
import { GenerateDisplayId } from "../../../utils/GenerateDisplayId";
import { Search } from "@mui/icons-material";
import DeleteModel from "../../CommonComponent/DeleteModel";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import noData from "../../../assets/images/Group 688.png";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#26875C" : "#26875C",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,.35)"
        : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));

const QuestionMasterContent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state?.user?.isLoading);
  const CompanyID = localStorage.getItem("companyID");

  const checklistQuestionMasterPagination = useSelector(
    (state) => state?.masters?.checklistQuestionMasterPagination
  );

  const departmentMasterData = useSelector(
    (state) => state?.masters?.departmentMasterData
  );

  const [isdeleteModel, setIsdeleteModel] = useState(false);
  const [SearchByQuestionValue, setSearchByQuestionValue] = useState("");
  const AddQuestionModel = useSelector(
    (state) => state?.masters?.models?.AddQuestionMasterModel
  );
  const [questionMasterDeleteID, setQuestionMasterDeleteID] = useState("");
  const [activeButton, setActiveButton] = useState("Daily");
  const [isActive, setIsActive] = useState("true");
  const [Department, setDepartment] = useState("");
  const [isPaginationLimit, setIsPaginationLimit] = useState(10);
  const [page, setPage] = useState(1);

  const handleChangeIsPaginationLimit = (event) => {
    setIsPaginationLimit(event.target.value);
  };

  const handleChangePage = (e, pagevalue) => {
    setPage(pagevalue);
  };

  const handleChangeDepartment = (event) => {
    setDepartment(event.target.value);
  };

  const handleChangeIsActive = (event) => {
    setIsActive(event.target.value);
  };
  const handleButtonClick = (btnname) => {
    setActiveButton(btnname);
  };

  const handleChangeSearchByQuestionValue = (event) => {
    setSearchByQuestionValue(event.target.value);
  };

  const handleDeleteQuestionMaster = () => {
    dispatch(
      deleteQuestionChecklistMasterList({
        id: questionMasterDeleteID,
      })
    );
    handleClosedeleteModel();
  };

  const toggleActiveStatus = (QuestionRowData) => {
    dispatch(
      updateQuestionMasterList({
        id: QuestionRowData?.id,
        active: !QuestionRowData?.active,
        question: QuestionRowData?.question,
        checklist_type_id: QuestionRowData?.checklist_type_id,
        department_id: QuestionRowData?.department_id,
      })
    );
  };

  const handleClosedeleteModel = (e) => {
    setIsdeleteModel(false);
  };

  useEffect(() => {
    dispatch(
      getChecklistQuestionMasterList({
        company_id: CompanyID,
        searchByQuestion: SearchByQuestionValue,
        checklist_type: activeButton,
        active: isActive,
        department_id: Department,
        limit: isPaginationLimit,
        offset: page - 1,
      })
    );
  }, [
    SearchByQuestionValue,
    isActive,
    activeButton,
    Department,
    isPaginationLimit,
    page,
  ]);

  const questionChecklistMaster = useSelector(
    (state) => state?.masters?.questionChecklistMasterData
  );

  useEffect(() => {
    dispatch(setIsOpenModelAddQuestionMaster(false));
    const payload = {
      isOpenEditModel: false,
      EditRowDataModel: [],
    };
    dispatch(setIsOpenModelEditQuestionMaster(payload));
    dispatch(setLoaderSaveButton(false));
  }, []);

  const handleEditQuestion = (QuestionData) => {
    const payload = {
      isOpenEditModel: true,
      EditRowDataModel: QuestionData,
    };
    dispatch(setIsOpenModelEditQuestionMaster(payload));
  };

  const onExportHandler = () => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    const exportFormShape = questionChecklistMaster?.map((user) => {
      return {
        "Sr.No": GenerateDisplayId("MM" + "QM", user?.display_id),
        Question: user.question,
        // "Order Number": user.oredernumber,
        "Checklist Type	": user.check_list_type_info?.name,
        Department: user.department_info?.name,
        "Created Date And Time": moment(user?.createdAt).format(
          "D MMMM, YYYY | hh:mm A"
        ),
        "Modified Date And Time": moment(user?.updatedAt).format(
          "D MMMM, YYYY | hh:mm A"
        ),
      };
    });
    const ws = XLSX.utils.json_to_sheet(exportFormShape);

    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, "Checklist Question Master" + fileExtension);
  };

  // useEffect(() => {
  //   if (!AddQuestionModel) {
  //     setSearchByQuestionValue("");
  //   }
  // }, [AddQuestionModel]);

  return (
    <>
      {isdeleteModel && (
        <DeleteModel
          isdeleteModel={isdeleteModel}
          handleClosedeleteModel={handleClosedeleteModel}
          handleDelete={handleDeleteQuestionMaster}
        />
      )}
      <AddQuestionMasterModel />

      <EditQuestionMasterModel />

      <Paper
        sx={{
          width: "auto",
          height: "auto",
          overflow: "auto",
          borderRadius: "10px",
        }}
      >
        <Box
          sx={{
            height: "80px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "20px",
            overflow: "auto",
            width: "auto",
            "&::-webkit-scrollbar": {
              width: "5px",
              height: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#20724E",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#E5F1EB",
            },
          }}
        >
          <Box sx={{ display: "flex" }}>
            <Box
              sx={{
                display: "flex",
                ml: 2,
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                navigate("/masters");
              }}
            >
              <img src={BackArrow} alt="" width="17" height="17" />
            </Box>
            <Box>
              <Typography
                sx={{
                  ml: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#212121",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Checklist Question Master
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: "flex" }}>
            <Box
              sx={{ display: "flex", alignItems: "center", gap: "10px", mr: 2 }}
            >
              <Box sx={{ display: "flex", mr: 2, alignItems: "center" }}>
                <Typography
                  onClick={() => handleButtonClick("Monthly")}
                  sx={{
                    padding: "9px 15px 9px 15px",
                    fontSize: "15px",
                    cursor: "pointer",
                    fontWeight: 600,
                    borderRadius: "15px",
                    color: activeButton === "Monthly" ? "#FFFFFF" : "#B5B5C3",
                    backgroundColor:
                      activeButton === "Monthly" ? "#20704D" : "transparent",
                  }}
                >
                  Monthly
                </Typography>
                <Typography
                  onClick={() => handleButtonClick("Weekly")}
                  sx={{
                    padding: "9px 15px 9px 15px",
                    fontSize: "15px",
                    cursor: "pointer",
                    fontWeight: 600,
                    borderRadius: "15px",
                    color: activeButton === "Weekly" ? "#FFFFFF" : "#B5B5C3",
                    backgroundColor:
                      activeButton === "Weekly" ? "#20704D" : "transparent",
                  }}
                >
                  Weekly
                </Typography>
                <Typography
                  onClick={() => handleButtonClick("Daily")}
                  align="center"
                  sx={{
                    padding: "9px 15px 9px 15px",
                    fontSize: "15px",
                    cursor: "pointer",
                    fontWeight: 600,
                    borderRadius: "15px",
                    color: activeButton === "Daily" ? "#FFFFFF" : "#B5B5C3",
                    backgroundColor:
                      activeButton === "Daily" ? "#20704D" : "transparent",
                  }}
                >
                  Daily
                </Typography>
              </Box>
              <Select
                value={Department}
                onChange={handleChangeDepartment}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                IconComponent={() => (
                  <Box
                    sx={{
                      marginRight: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={ArrowDown}
                      alt="Custom Icon"
                      width="18"
                      height="24"
                    />
                  </Box>
                )}
                sx={{
                  height: "37px",
                  width: "11rem",
                  color: "#20724E",
                  fontWeight: "bold",
                  borderRadius: "10px",
                  backgroundColor: "#E5F1EB",
                  border: "none",
                  mr: 2,
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #E5F1EB",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              >
                <MenuItem value="">Department</MenuItem>
                {departmentMasterData?.map((row) => (
                  <MenuItem value={row?.id}>{row?.name}</MenuItem>
                ))}
              </Select>
              <Select
                value={isActive}
                onChange={handleChangeIsActive}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                IconComponent={() => (
                  <Box
                    sx={{
                      marginRight: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={ArrowDown}
                      alt="Custom Icon"
                      width="16"
                      height="24"
                    />
                  </Box>
                )}
                sx={{
                  height: "37px",
                  width: "11rem",
                  color: "#20724E",
                  fontWeight: "bold",
                  borderRadius: "10px",
                  border: "none",
                  backgroundColor: "#E5F1EB",
                  mr: 1,
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #E5F1EB",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="true">Active</MenuItem>
                <MenuItem value="false">InActive</MenuItem>
              </Select>
              <TextField
                size="small"
                placeholder="Search Question"
                value={SearchByQuestionValue}
                onChange={handleChangeSearchByQuestionValue}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search sx={{ color: "#20724E" }} />
                    </InputAdornment>
                  ),
                  style: {
                    height: "2.3rem",
                    borderRadius: "10px",
                    color: "#20724E",
                    fontWeight: "bold",
                    width: "15rem",
                    backgroundColor: "#E5F1EB",
                  },
                }}
                sx={{
                  mr: 2,
                  ml: 1,
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #E5F1EB",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <Button
                variant="outlined"
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  borderColor: "#26875C",
                  width: "6rem",
                  backgroundColor: "FFFFFF",
                  padding: "6px 0px 4px 0px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#26875C",
                  ":hover": {
                    borderColor: "#26875C",
                  },
                }}
                onClick={() => dispatch(setIsOpenModelAddQuestionMaster(true))}
              >
                <Box sx={{ marginRight: "10px" }}>
                  <img src={ActiveAddButton} alt="" />
                </Box>
                Add
              </Button>
              <Button
                variant="contained"
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  width: "6rem",
                  backgroundColor: "#26875C",
                  padding: "7px 0px 5px 0px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#FFFFFF",
                  ":hover": {
                    backgroundColor: "#26875C",
                  },
                }}
                // onClick={() => setIsAddChecklistModel(true)}
                onClick={() => (isLoading ? null : onExportHandler())}
              >
                Export
              </Button>
            </Box>
          </Box>
        </Box>
        <Divider sx={{ width: "auto" }} />

        <Box sx={{ margin: "10px 25px 20px 25px" }}>
          <TableContainer
            sx={{
              maxHeight: "620px",
              "&::-webkit-scrollbar": {
                width: "5px",
                height: "3px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#20724E",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#E5F1EB",
              },
            }}
          >
            {questionChecklistMaster.length <= 0 ? (
              <Grid sx={{ paddingTop: "20px" }}>
                <Grid
                  item
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box>
                    <Box
                      component="img"
                      sx={{
                        height: "25rem",
                        width: "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      alt=""
                      src={noData}
                    />
                  </Box>
                  <Box
                    fontWeight="600"
                    sx={{ padding: "20px", fontWeight: "600" }}
                  >
                    <Typography sx={{ fontWeight: "600", fontSize: "18px" }}>
                      No Data Found
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            ) : (
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {/* <TableCell sx={{ color: "#B5B5C3", fontWeight: 600 }}>
                      Role Id
                    </TableCell> */}
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Sr.No
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Question
                    </TableCell>
                    {/* <TableCell
                    sx={{
                      color: "#B5B5C3",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    Order Number
                  </TableCell> */}
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Checklist Type
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Department
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Created Date
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Last Modified Date
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Status
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Action
                    </TableCell>
                    {/* <TableCell sx={{ color: "#B5B5C3", fontWeight: 600 }}>
                    Active
                  </TableCell> */}
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                {isLoading ? (
                  <TableBody>
                    <TableRow
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        height: "10rem",
                      }}
                    >
                      <TableCell colSpan={8} align="center">
                        <CircularProgress color="success" />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {questionChecklistMaster?.map((row, index) => (
                      <TableRow
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        {/* <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {row?.id}
                        </TableCell> */}
                        <TableCell
                          sx={{
                            color: "#464E5F",
                            fontWeight: 600,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {GenerateDisplayId("MM" + "QM", row?.display_id)}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {row?.question}
                        </TableCell>
                        {/* <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                        {row?.oredernumber}
                      </TableCell> */}
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {row?.check_list_type_info?.name}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {row?.department_info?.name}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {moment(row?.createdAt).format(
                            "D MMMM, YYYY | hh:mm A"
                          )}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {/* {row?.updatedAt} */}
                          {moment(row?.updatedAt).format(
                            "D MMMM, YYYY | hh:mm A"
                          )}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          <Box onClick={() => toggleActiveStatus(row)}>
                            <AntSwitch checked={row.active} color="primary" />
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: "flex" }}>
                            <IconButton onClick={() => handleEditQuestion(row)}>
                              <img src={EditButton} width="30" height="30" />
                            </IconButton>

                            <IconButton
                              onClick={() => {
                                setQuestionMasterDeleteID(row?.id);
                                setIsdeleteModel(true);
                              }}
                            >
                              <img src={TrashButton} width="30" height="30" />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            )}
          </TableContainer>
          <Divider />
          {checklistQuestionMasterPagination?.totalRecord >= TOTALLIMIT && (
            <Stack
              spacing={2}
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              sx={{
                padding: "1rem",
                marginTop: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ mr: "8px" }}>Row Per Page</Typography>
                <Select
                  value={isPaginationLimit}
                  onChange={handleChangeIsPaginationLimit}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  IconComponent={() => (
                    <Box
                      sx={{
                        marginRight: "10px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={ArrowDown}
                        alt="Custom Icon"
                        width="18"
                        height="24"
                      />
                    </Box>
                  )}
                  sx={{
                    height: "37px",
                    width: "6rem",
                    color: "#20724E",
                    fontWeight: "bold",
                    borderRadius: "10px",
                    border: "none",
                    backgroundColor: "#E5F1EB",
                    mr: 2,
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      border: "1px solid #E5F1EB",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={30}>30</MenuItem>
                </Select>
              </Box>
              <Box>
                <Pagination
                  count={checklistQuestionMasterPagination?.totalPages}
                  onChange={handleChangePage}
                  renderItem={(item) => (
                    <PaginationItem
                      slots={{
                        previous: ArrowBackIcon,
                        next: ArrowForwardIcon,
                      }}
                      {...item}
                    />
                  )}
                />
              </Box>
            </Stack>
          )}
        </Box>
      </Paper>
    </>
  );
};

export default QuestionMasterContent;
